var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-row__item circle-row__item--total"},[_vm._t("title",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.title || '')+" ")])]}),_vm._t("amount",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.amount || '')+" ")])]}),_c('g-chart',{staticClass:"pie-chart-total",attrs:{"type":"PieChart","settings":{ packages: ['corechart'] },"data":_vm.data,"options":{
      enableInteractivity: false,
      width: '96px',
      height: '96px',
      chartArea: { width: '100%', height: '100%', top: '0', left: '0' },
      legend: { position: 'none' },
      pieHole: 0.9,
      slices: _vm.slices
    }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }